module.exports = __webpack_public_path__ + "static/p13_becerroOrejaR-fcce802a4fb38553cc63b4c588f33b32.png";